<div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        <div class="content">
            <div class="flex flex-auto items-center justify-between w-full mb-2">
                <h2 class="text-3xl font-bold leading-8">
                   {{ "BRAND_FACTORY_CONNECTION_COMPONENT.PARTNER_CONNECTION_TITLE"  | translate }} 
                </h2>
            </div>
            <div class="flex flex-auto">
                <p class="text-lg font-normal">
                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.PARTNER_CONNECTION_SUB_TITLE"  | translate }} 
                </p>
            </div>
        </div>

        <div class="flex flex-col flex-auto min-w-0">
            <!-- Main -->
            <div class="flex-auto sm:pt-3">
                <div class="content">
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                        (selectedTabChange)="onTabChanged($event.index)">
                        <!-- TAB 1 : Manage existing and pending connections-->
                        <mat-tab label="{{ 'BRAND_FACTORY_CONNECTION_COMPONENT.TABS.MANAGE_EXISTING_TAB'  | translate }} ">                
                           
                            <app-my-connection-list></app-my-connection-list>

                        </mat-tab>

                        <!-- TAB 2 : Send new connection requests. -->
                        <mat-tab label="{{ 'BRAND_FACTORY_CONNECTION_COMPONENT.TABS.SEND_NEW_CONN_TAB'  | translate }}">
                            <div class="flex w-2/4 flex-col flex-auto ml-auto justify-end">
                                <mat-tab-group mat-stretch-tabs="'false'" mat-align-tabs="end" (selectedIndexChange)="
                                        onChildTabChanged($event)
                                    ">
                                    <!-- TAB 2.1 : Search to Connect -->
                                    <mat-tab label="{{ 'BRAND_FACTORY_CONNECTION_COMPONENT.TABS.SEARCH_TO_CONNECT_TAB'  | translate }}">
                                    </mat-tab>

                                    <!-- TAB 2.2 : Bulk Connection -->
                                    <mat-tab label="{{ 'BRAND_FACTORY_CONNECTION_COMPONENT.TABS.BULK_CONNECTION_TAB'  | translate }}"> </mat-tab>
                                </mat-tab-group>
                            </div>

                            <!-- TAB 2.1 : Search to Connect Content Display -->
                            <ng-container *ngIf="childTabDisplay == 0">

                                <app-searched-list></app-searched-list>

                            </ng-container>

                            <!-- TAB 2.2 : Bulk Connection Content Display -->
                            <ng-container *ngIf="childTabDisplay == 1">
                                <div class="flex flex-auto items-center justify-between w-full mb-4">
                                    <h2 class="text-2xl font-bold leading-8">
                                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.BULK_CONNECTION_SUB_TITLE"  | translate }} 
                                    </h2>
                                </div>

                                <!-- Download Excel File  -->
                                <div class="mt-4 p-4 bg-gray-200">
                                    <div class="flex justify-between">
                                        <div class="pl-4">
                                            <strong>
                                                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.DOWNLOAD_EXCEL_FILE_TITLE"  | translate }}
                                            </strong>
                                            <br />
                                            <span>
                                                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.DOWNLOAD_EXCEL_FILE_INSTRUCTION"  | translate }} 
                                            </span>
                                        </div>
                                        <button class="choose-button flex justify-end"
                                            (click)="downloadExcelWorkspace()">
                                            {{ "BRAND_FACTORY_CONNECTION_COMPONENT.DOWNLOAD_EXCEL_FILE_BUTTON"  | translate }} 
                                        </button>
                                    </div>
                                </div>

                                <!-- Upload Excel File For Bulk Connection  -->
                                <div class="mt-4 p-4 bg-gray-200">
                                    <div class="flex justify-between">
                                        <div class="pl-4">
                                            <strong>
                                                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.UPLOAD_EXCEL_FILE_TITLE"  | translate }}  
                                            </strong>
                                            <br />

                                            <input class="flex justify-end" placeholder="{{
                                                    'BRAND_FACTORY_CONNECTION_COMPONENT.UPLOAD_EXCEL_SELECT_FILE'
                                                        | translate
                                                }}" type="file" (change)="
                                                    addFile($event.target.files)
                                                " id="file" #fileUploadVariable
                                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                        </div>

                                        <button class="choose-button flex justify-end" (click)="upload()">
                                            {{ "BRAND_FACTORY_CONNECTION_COMPONENT.UPLOAD_EXCEL_FILE_BUTTON"  | translate }} 
                                        </button>
                                    </div>
                                </div>

                                <div class="flex flex-auto items-center justify-between w-full mb-4">
                                    <h2 class="text-lg font-normal leading-8">
                                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.BULK_CONNECTION_INSTRUCTION"  | translate }}  
                                    </h2>
                                </div>


                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </div>

                <!--  @ Match Existing Contact Partner Table i.e. Bulk Connection -->
                <ng-container *ngIf="isCheckMatchPatners">
                    <!--  @ Match Partner Section  -->
                    <div class="flex flex-col flex-auto mt-1">
                        <!-- Main -->
                        <div class="flex-auto sm:pt-3">
                            <div class="content">
                                <div class="flex flex-auto items-center justify-between w-full mb-4">
                                    <h2 class="text-2xl font-bold leading-8">
                                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.EXISTING_CONTACTS_BULK_CONNECTION_TITLE"  | translate }}   
                                    </h2>
                                </div>
                                
                                <div class="flex flex-auto">
                                    <p class="text-lg font-normal">
                                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.EXISTING_CONTACTS_BULK_CONNECTION_SUB_TITLE"  | translate }}    
                                    </p>
                                </div>

                                <div *ngIf="uploadFactoryListDataSource != null" class="w-full pt-2" stricky>
                                    <div class="p-0 example-container">
                                        <table mat-table [dataSource]="uploadFactoryListDataSource" matSort
                                            class="w-full font-normal text-base p-0">
                                            <!-- Company Name Column -->
                                            <ng-container matColumnDef="Company Name">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_COMPANY_NAME"  | translate }}        
                                                </th>
                                                <td mat-cell *matCellDef="let row"
                                                    [ngStyle]="{ color:  row.requestTo == undefined? 'red': 'green' }">
                                                    {{ row.requestToName }}
                                                    <br />
                                                    <!-- {{
                                                    row.matchedSupplierName
                                                    }} -->
                                                </td>
                                            </ng-container>

                                            <!-- Role Column -->
                                            <ng-container matColumnDef="Role">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_ROLE"  | translate }}    
                                                </th>
                                                <td mat-cell *matCellDef="let row"
                                                    [ngStyle]="{color: row.isAlreadyConnected ? 'green': '' }">
                                                    {{ row.Status }}
                                                </td>
                                            </ng-container>

                                            <!-- Supplier ID Column -->
                                            <ng-container matColumnDef="Supplier ID">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_SUPPLIER_ID"  | translate }} 
                                                </th>
                                                <td mat-cell *matCellDef="let row"
                                                    [ngStyle]="{color: row.isAlreadyConnected ? 'green': '' }">
                                                    {{ row.name }}
                                                </td>
                                            </ng-container>

                                            <!-- Walmart Mill ID Column -->
                                            <ng-container matColumnDef="Walmart Mill ID">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_WALMART_MILL_ID"  | translate }} 
                                                </th>
                                                <td mat-cell *matCellDef="let row">
                                                    {{ row.name }}
                                                </td>
                                            </ng-container>

                                            <!-- Matchtype -->
                                            <ng-container matColumnDef="matchType">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                                                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_MATCHED_WITH"  | translate }} 
                                                </th>
                                                <td mat-cell *matCellDef="let row">
                                                    {{ row.matchType }}
                                                </td>
                                            </ng-container>

                                            <!-- Database Connection Column -->
                                            <ng-container matColumnDef="databaseMatch">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_DATABASE_MATCH"  | translate }} 
                                                </th>
                                                <td mat-cell *matCellDef="let row">
                                                    <mat-form-field  *ngIf="!row.isAlreadyConnected " 
                                                        [appearance]=" row.isActiveRow && row.searches != null ? 'outline' : 'none' "
                                                        (click)=" removeMatching(row) " style="width: 90%">
                                                        <input id="myInputMatch{{ index }}" matInput type="text"
                                                            [matAutocomplete]=" auto "
                                                            [placeholder]=" row.isActiveRow ? 'Search by name' : 'Correct the match'"
                                                            [formControl]="control " (click)="removeMatching(row)" />

                                                        <mat-autocomplete panelWidth="auto" autoActiveFirstOption
                                                            #auto="matAutocomplete">
                                                            <mat-option
                                                                *ngIf="row.searches ==null || row.searches.length == 0 "
                                                                class="flex flex-stretch">
                                                                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.NOT_FOUND_RECORD"  | translate }}   
                                                            </mat-option>

                                                            <mat-option *ngFor="let res of row.searches; let z = index "
                                                                [value]="res.id" (click)="onMatchClick(row, res ) ">
                                                                {{ res.name }}
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>

                                            <!-- Connection Status Column -->
                                            <ng-container matColumnDef="Connect">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <div>
                                                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_CONNECT"  | translate }} 
                                                        <br />
                                                        <mat-checkbox (change)="
                                                                onCheckedAll(
                                                                    $event.checked,
                                                                    uploadFactoryListDataSource
                                                                )
                                                            " [(ngModel)]="
                                                                matchedAllSelect
                                                            " color="primary">
                                                        </mat-checkbox>
                                                        <label class="text-base font-medium">
                                                            {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_SELECT_ALL"  | translate }}
                                                        </label>
                                                    </div>
                                                </th>
                                                <td mat-cell *matCellDef="
                                                        let row;
                                                        let i = index
                                                    ">
                                                    <mat-checkbox *ngIf="!row.isAlreadyConnected "  [(ngModel)]="row.checked" color="primary"
                                                        (change)=" matchedAllSelect = false ">
                                                    </mat-checkbox>

                                                    <p *ngIf="row.isAlreadyConnected " style="color: green;">
                                                        <em>{{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.CONNECTED"  | translate }}</em>
                                                    </p>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="
                                                    bulkExistingMatchDisplayedColumns;
                                                    sticky: true
                                                "></tr>
                                            <tr mat-row *matRowDef="
                                                    let row;
                                                    columns: bulkExistingMatchDisplayedColumns
                                                "></tr>

                                            <!-- Row shown when there is no matching data. -->
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" colspan="4">
                                                    {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_NO_DATA_MATCHING_FILTER"  | translate }} 
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <!-- ACTION BUTTON => Delete & Connect Request -->
                                    <div class="mt-4 flex justify-end pr-0">
                                        <button *ngIf="
                                                uploadFactoryListDataSource.data
                                                    .length > 0
                                            " (click)="
                                                addMultipleBrandConnection()
                                            " class="btn btn-primary mr-2">
                                            {{ "BRAND_FACTORY_CONNECTION_COMPONENT.SEND_REQUEST_BUTTON"  | translate }} 
                                        </button>
                                        <button *ngIf="
                                                uploadFactoryListDataSource.data
                                                    .length > 0
                                            " (click)="onSelectedDelete()" class="btn btn-danger">
                                            {{ "BRAND_FACTORY_CONNECTION_COMPONENT.DELETE_BUTTON"  | translate }} 
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!--  @ Pending Request Status Section Start Here -->
                <ng-container *ngIf="!MngExstingTab" >
                    <div class="flex flex-col flex-auto min-w-0">
                        <!-- Main -->
                        <div class="flex-auto sm:pt-3">
                            <div class="content">
                                <div class="flex flex-auto items-center justify-between w-full mb-2">
                                    <h2 class="text-2xl font-bold leading-8">
                                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.PENDING_REQUEST_STATUS_TITLE"  | translate }}    
                                    </h2>
                                </div>
    
                                <div class="flex flex-auto">
                                    <p class="text-lg font-normal">
                                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.PENDING_REQUEST_STATUS_SUB_TITLE"  | translate }}   
                                    </p>
                                </div>
    
                                <app-sent-request-list [type]="1"></app-sent-request-list>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>